import React from "react";
import { CatalogosHomeItemDetalle } from "./CatalogosHomeItemDetalle";

function CatalogosHomeItem(props) {
  const displayItems = (props) => {
    const catalogosHome = props.catalogosHome

    if (catalogosHome.length > 0) {
      return catalogosHome.map((catalogoHome, index) => {
        return <CatalogosHomeItemDetalle key={index} catalogoHome={catalogoHome} />
      })
    } else {
      return <h3>No hay imagenes de catalogo</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {CatalogosHomeItem}